module.exports = __webpack_public_path__ + "static/gallery-14-a383822ca373d02ea683a107aecbed48.jpg";